/* eslint-disable */
import { DrawerComponent } from 'components/Drawer';
import styled, { css } from 'styled-components';
export const Header = styled.div`
  ${({ theme }) => css`
    gap: 1rem;
    display: flex;
    padding: 2rem;
    flex-shrink: 0;
    background: #f5f5f5;
    flex-direction: column;
    border-bottom: 0.0625rem solid #d8d8d8;
  `}
`;
export const Box = styled.div`
  ${({ theme }) => css`
    padding: 1.5rem;
    margin-top: 16px;
    margin-bottom: 16px;
    border: 0.0625rem solid #d8d8d8;
    border-radius: 0.8rem;
  `}
`;
export const TextInfos = styled.span<{
  color?: string;
  lineWeight?: string;
  size?: string;
  mt?: string;
  cursor?:boolean
}>`
  ${({ color, lineWeight, size, mt ,cursor }) => css`
    font-weight: ${lineWeight ?? '700'};
    line-height: 2rem;
    color: ${color || '#000'};
    align-items: center;
    cursor: ${cursor && "pointer"};
    font-size: ${size ?? '16'}px;
    margin-top: ${mt || '0'};
  `}
`;
export const BoxContent = styled.div`
  ${({ theme }) => css`
    padding: 1.5rem;
  `}
`;
export const Form = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: space-between;
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  `}
`;
export const BoxFooter = styled.div`
  ${() => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
  `}
`;
export const ContentFooter = styled.div`
  ${() => css`
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    gap: 0.25rem;
  `}
`;
export const StyledDrawer = styled(DrawerComponent)`
  ${() => css`
    display: flex;
    gap: 1.5rem;
    padding: 0 !important;
    flex-direction: column;
    position: relative;
    max-height: 100vh !important;

    &:last-child {
      border-top: 1px solid #d8d8d8;
    }
  `}
`;
export const Infos = styled.div`
  ${() => css`
    gap: 1.5rem;
    display: flex;
    justify-content: space-between;
  `}
`;
export const Profile = styled.div`
  ${({ theme }) => css`
    gap: 1rem;
    display: flex;
    font-weight: 700;
    line-height: 2rem;
    letter-spacing: -0.05rem;
    font-size: ${theme.font.sizes.large || '24px'};
  `}
`;

export const Close = styled.div`
  ${({ theme }) => css`
    cursor: pointer;
    stroke-width: 3rem;
    stroke: ${theme.colors.neutral.neutral100 || '#000'};
    font-size: ${theme.font.sizes.medium || '16px'};
  `}
`;
export const Subtitle = styled.span`
  ${({ theme }) => css`
    font-weight: 500;
    line-height: 2rem;

    align-items: center;
    font-size: 16px;
  `}
`;
export const TitleValue = styled.span`
  ${({ theme }) => css`
    font-weight: 500;
    line-height: 2rem;
    display: flex;
    font-size: 12px;
    color: ${theme.colors.neutral.neutral50 || '#808080'};
  `}
`;
export const Value = styled.div`
  ${({ theme }) => css`
    font-weight: 700;
    line-height: 2rem;
    display: flex;
    font-size: 24px;
  `}
`;
export const SubtitleBold = styled.span`
  ${({ theme }) => css`
    font-weight: 700;
    line-height: 2rem;
    font-size: 16px;
  `}
`;
export const Loader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const Main = styled.main`
  ${() => css`
    gap: 1.5rem;
    display: flex;
    overflow: auto;
    padding: 16px 32px;
    flex-direction: column;
    height: calc(100% - 185px);
  `}
`;
export const DrawerFooter = styled.div`
  ${() => css`
    border-top: 1px solid #d8d8d8;
    padding: 1rem 2rem;
    display: flex;
    gap: 1rem;
    justify-content: flex-end;
    align-items: center;
  `}
`;
export const CustomButton = styled.button<{
  variant?: 'primary' | 'secondary' | 'link';
}>`
  ${({ theme, variant = 'primary' }) => css`
    padding: 12px 24px;
    border-radius: ${theme.border.radius || '8px'};
    font-weight: 600;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    border: 1px solid;

    ${variant === 'primary' &&
    css`
      background-color: ${theme.colors.primary50};
      color: #ffffff;
      border-color: ${theme.colors.primary50};

      &:hover {
        background-color: ${theme.colors.primary70};
        border-color: ${theme.colors.primary70};
      }
    `}

    ${variant === 'secondary' &&
    css`
      background-color: transparent;
      color: ${theme.colors.primary50};
      border-color: ${theme.colors.primary50};

      &:hover {
        background-color: ${theme.colors.primary50};
        color: #ffffff;
      }
    `}

    ${variant === 'link' &&
    css`
      background-color: transparent;
      color: ${theme.colors.primary50};
      border: none;

      border-radius: 0;

      /* Remove hover effects */
      &:hover {
        background-color: transparent;
        color: ${theme.colors.primary50};
      }
    `}
  `}
`;
export const ProgressBar = styled.div<{ percentage: string }>`
  ${({ percentage }) => css`
    width: 100%;
    height: 8px;
    border-radius: 4px;
    background: #f5f5f5;
    position: relative;
    margin: 1rem 0;
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: ${percentage}%;
      height: 100%;
      border-radius: 4px;
      background: linear-gradient(to right, #298ee6, #1a344d);
    }

    ${percentage === '100' &&
    css`
      display: flex;
      align-items: center;
      justify-content: flex-end;

      svg {
        position: absolute;
        right: -4px;
        z-index: 1;
      }
    `}
  `}
`;
export const TextAside = styled.div<{
  fontWeight?: string;
  color?: string;
  fontSize?: string;
}>`
  ${({ fontWeight, color, fontSize }) => css`
    font-size: ${fontSize ? `${fontSize}px` : '16px'};
    line-height: 24px;
    letter-spacing: -0.4px;
    color: ${color ? color : 'black'};
    font-weight: ${fontWeight ? fontWeight : '500'};
  `}
`;
export const Grid = styled.div`
  display: grid;
  margin-bottom: 16px;
  grid-template-columns: repeat(2, 1fr); /* 2 colunas */
  gap: 8px; /* Espaçamento entre os itens */

  @media (max-width: 800px) {
    grid-template-columns: 1fr; /* 1 coluna quando a largura for menor que 800px */
  }
`;
